import { store } from 'Shared/react-initialize';
import * as HeaderActions from 'Shared/Header/actions';
import Notifications from './notifications';
import NotificationsClient from './notifications_client';

export function initializeNotificationsService() {
   if (window.notificationService || !App.isLoggedIn) {
      return;
   }

   window.notificationService = new NotificationService();
   window.notificationService.initialize();
}

class NotificationService {
   constructor() {
      this._notifications = new Notifications(this._markRead, this._markAllRead);
      this._dispatch();
   }

   initialize() {
      this._notifications.initializeNotifications(App.initialNotifications, App.unreadCount);

      if (App.realtimeEnabled) {
         this._connect();
      }
   }

   _connect() {
      this._connection = new NotificationsClient({
         onNotification: this._addNewNotification,
         onMarkRead: notificationSigs => {
            notificationSigs.forEach(this._notifications.setNotificationAsRead);
            this._dispatch();
         },
         onMarkAllRead: () => this._dispatchMarkAllRead(),
      });
      this._connection.start();
   }

   _dispatch() {
      this._notifications = this._notifications.clone();
      store.dispatch(HeaderActions.updateNotifications(this._notifications));
   }

   _dispatchMarkAllRead() {
      this._notifications.setAllNotificationsAsRead();
      this._dispatch();
   }

   _addNewNotification = notification => {
      this._notifications.addNewNotification(notification);
      this._dispatch();
   };

   _markRead = notification => {
      notification.setRead();
      this._dispatch();
      NotificationsClient.markRead(notification.signature);
   };

   _markAllRead = () => {
      this._dispatchMarkAllRead();
      NotificationsClient.markAllRead();
   };
}
